module.exports = __webpack_public_path__ + "assets/img/icon-failed-bid.fcd51dd9.png";